import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#custom-column-template" }),
  /*#__PURE__*/_createTextVNode(" Custom column template ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Customize table column so it can be integrated with other components. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-time" }, null, -1)
const _hoisted_6 = { style: {"margin-left":"10px"} }
const _hoisted_7 = { class: "name-wrapper" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Delete")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "Date",
            width: "180"
          }, {
            default: _withCtx((scope) => [
              _hoisted_5,
              _createVNode("span", _hoisted_6, _toDisplayString(scope.row.date), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Name",
            width: "180"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_popover, {
                effect: "light",
                trigger: "hover",
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode("p", null, "姓名: " + _toDisplayString(scope.row.name), 1),
                  _createVNode("p", null, "住址: " + _toDisplayString(scope.row.address), 1)
                ]),
                reference: _withCtx(() => [
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_el_tag, { size: "medium" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.name), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Operations" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "mini",
                onClick: ($event: any) => (_ctx.handleEdit(scope.$index, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                size: "mini",
                type: "danger",
                onClick: ($event: any) => (_ctx.handleDelete(scope.$index, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code14), 1)
        ]),
        _: 1
      })
    ])
  ]))
}